




















import Vue from 'vue';
import Component from 'vue-class-component';
import { checkForNoBreakClass } from '@/common/ts/brand-safe-hypens/BrandSafeHyphens';
import { Watch } from 'vue-property-decorator';
import IntersectionDirective from './intersection-directive';

const WordFadeProps = Vue.extend({
  props: {
    animatedText: String,
    manualFade: {
      type: Boolean,
      default: false,
    },
    fadeToOpacity: {
      type: Number,
      default: 1,
    },
    manualFadeIn: Boolean,
    delay: Number,
    interimDelay: {
      type: Number,
      default: 75,
    },
    textAlign: {
      type: String,
      default: 'left',
      validator: (val) => ['left', 'right', 'center', 'desktop-center', 'always-center'].includes(val),
    },
  },
});

@Component({
  directives: {
    intersect: IntersectionDirective,
  },
})
export default class WordFade extends WordFadeProps {
  textFadeIn = false;
  visibleTextBlock = -1;
  isHiddenAbove = false;

  get rootClass () {
    return {
      'brandhub-word-fade--left': this.textAlign === 'left',
      'brandhub-word-fade--right': this.textAlign === 'right',
      'brandhub-word-fade--center': this.textAlign === 'center',
      'brandhub-word-fade--desktop-center': this.textAlign === 'desktop-center',
      'brandhub-word-fade--always-center': this.textAlign === 'always-center',
    };
  }

  get splittedText () {
    return this.animatedText
      .replace('<br />', '<br/> ')
      .split(' ');
  }

  filteredWord (word: string) {
    return word.replace('<br/>', '');
  }

  @Watch('manualFadeIn')
  checkFade (newValue: boolean) {
    if (!this.manualFade) {
      return;
    }
    if (newValue && !this.textFadeIn) {
      this.fadeInText();
    }
    if (!newValue && this.textFadeIn) {
      this.fadeOutWord();
    }
  }

  handleIntersection (isIntersecting: boolean, el: HTMLElement) {
    if (!this.manualFade) {
      const { top } = el.getBoundingClientRect();
      // if element is now becoming visible from bottom
      if (isIntersecting || top <= 0) {
        this.fadeInText();
      } else if (!isIntersecting) {
        this.fadeOutWord();
      }
    }
  }

  fadeInText (fromBottom = true) {
    this.isHiddenAbove = !fromBottom;
    this.textFadeIn = true;
    this.fadeInWord(fromBottom);
  }

  fadeOutText () {
    this.$emit('fade-out-complete');
  }

  fadeInWord (fromBottom = true) {
    const initialDelay = Math.floor(this.visibleTextBlock === -1 && this.delay ? this.delay : 0);
    setTimeout(() => {
      this.visibleTextBlock += 1;
      if (this.visibleTextBlock + 1 < this.splittedText.length && this.textFadeIn) {
        setTimeout(() => {
          this.fadeInWord(fromBottom);
        }, this.interimDelay);
      }
    }, initialDelay);
  }

  fadeOutWord (toTop = false) {
    this.isHiddenAbove = toTop;
    this.textFadeIn = false;
    this.visibleTextBlock -= 1;
    if (this.visibleTextBlock < 0) {
      this.fadeOutText();
    } else if (!this.textFadeIn) {
      setTimeout(() => {
        this.fadeOutWord(toTop);
      }, 40);
    }
  }

  fadeInTextClass (wordText: string, textBlockIndex: number) {
    return {
      'brandhub-word-fade__word--visible': textBlockIndex <= this.visibleTextBlock,
      'brandhub-word-fade__word--hidden-above': this.isHiddenAbove,
      ...checkForNoBreakClass(wordText),
    };
  }

  mounted () {
    if (this.manualFade && this.manualFadeIn) {
      this.fadeInText();
    }
  }
}
